
import BasicSignUp from "modules/leads/AddLead";
import React, { Component } from "react";


const publicRoutes = [
  { path: "/lead/form", component: <BasicSignUp /> },
];

export { publicRoutes };
